import { Device } from "./types";

export const deviceToProvisioning = (device: Device) => {
  delete device.numOpenTickets;
  delete device.detailedStatuses;
  delete device.status;
  return device;
};
